// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3rkOh","head":"Table_head__2HoTU","col":"Table_col__nu8EW"};